export default class AccountCompletionForm {

	constructor(name) {
		window.dataLayer = window.dataLayer || [];
		window[name] = this.data()
	}



	data() {
		return {
			uid: null,
			loading: false,
			errorMessage: null,
			CompletionStep: 0,

			passwordFields: {
				password: null,
				password_confirmation: null
			},

			phoneFields: {
				phone: null,
				countryCode: '31',
				token: null
			},
			dashboardUrl: null,
			accountAlreadyRegistred: false,

			Init(uid){
				this.uid = uid;
				this.HandleEnterEvent();
			},

			StorePassword(){
				var vm = this;
				var xhttp = new XMLHttpRequest();
				vm.loading = true
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.loading = false
						var response = JSON.parse(this.responseText);
						if( vm.validate(response) == true ) return;
						vm.StepForward()
					}
				};
				xhttp.open('post', '/account/completion/'+vm.uid+'/store-password', true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send(JSON.stringify({
					password: vm.passwordFields.password,
					password_confirmation: vm.passwordFields.password_confirmation,
					uid: vm.uid,
				}));
			},

			StorePhone(){
				var vm = this;
				var xhttp = new XMLHttpRequest();
				vm.loading = true
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.loading = false
						var response = JSON.parse(this.responseText);
						if( vm.validate(response) == true ) return;
						vm.StepForward()
					}
				};
				xhttp.open('post', '/account/completion/'+vm.uid+'/store-phone', true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send(JSON.stringify({
					phone: vm.phoneFields.phone,
					countryCode: vm.phoneFields.countryCode,
					uid: vm.uid,
				}));
			},

			CheckToken(){
				var vm = this;

				if(vm.loading){
					return;
				}

				var xhttp = new XMLHttpRequest();
				vm.loading = true
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.loading = false
						var response = JSON.parse(this.responseText);

						if( vm.validate(response) == true ) return;

						if( ! response.data.CheckTokenInUncompletedAccount.uid ){
							alert('Uw account kan niet worden voltooid.')
							return;
						}
						window.dataLayer.push({'event': 'account_completed'});
						vm.StepForward()

					}
				};
				xhttp.open('post', '/account/completion/'+vm.uid+'/check-token', true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send(JSON.stringify({
					token: vm.phoneFields.token,
					uid: vm.uid,
				}));
			},

			StepBack(){
				var vm = this;
				if(vm.CompletionStep == 1) return
					vm.CompletionStep--
			},
			StepForward(){
				var vm = this;
				vm.CompletionStep++
			},

			validate(response){
				var vm = this;
				if (typeof(response.error) !== 'undefined') {
					vm.errorMessage = response.error
					return true
				}
				if (typeof(response.validation) !== 'undefined') {
					window.dataLayer.push({'event': 'account_completion_finished'});

					vm.ValidationResponse(response.validation);
					return true
				}
			},

			ValidationResponse(ValidationResponse) {
				var vm = this;
				document.querySelectorAll('.has-errors').forEach(el => el.classList.remove('has-errors'));
				document.querySelectorAll('.woonmens-validation-message').forEach(el => el.remove());
				if (typeof(ValidationResponse) !== 'undefined') {
					Object.keys(ValidationResponse).forEach(function(item) {
						if(ValidationResponse[item] == 'Account al geregistreerd'){
							vm.accountAlreadyRegistred = true;
						}
						var el = document.querySelector('[name="' + item + '"]')
						if (el) {
							el.parentNode.classList.add('has-errors')
							el.insertAdjacentHTML('afterend', '<div class="woonmens-validation-message">  <a href="#" data-tooltip="' +  ValidationResponse[item] + '"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" viewBox="0 0 22 22" width="22" height="22"><g transform="matrix(0.9166666666666666,0,0,0.9166666666666666,0,0)"><path d="M1.000 12.001 A11.000 11.000 0 1 0 23.000 12.001 A11.000 11.000 0 1 0 1.000 12.001 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.5,17.005H13a1,1,0,0,1-1-1v-6.5a.5.5,0,0,0-.5-.5H10" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.745 6.504L11.745 6.504" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.745,6.5a.25.25,0,1,0,.25.25.25.25,0,0,0-.25-.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></g></svg></a>  </div>');
							el.addEventListener('focus', function() {
								el.parentNode.classList.remove('has-errors')
								var next = el.nextSibling
								if( next ) next.remove();
							})
						}
					});
				};
			},
			HandleEnterEvent(){
				var vm = this;
				document.onkeypress = function (e) {
					if (e.keyCode == 13) {
						switch(vm.CompletionStep) {
							case 0:
							return vm.StepForward()
							break;
							case 1:
							return vm.StorePassword()
							break;
							case 2:
							return vm.StorePhone()
							break;
							case 3:
							return vm.CheckToken()
							break;
						}
					}
				};
			},
		}
	}
}
